import api from './index';
//
let exports = {};

// ============ 资产折旧记录 ========================

exports.getAssetDeprRecPagedList = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============ 资产折旧单 ========================

exports.getAssetDeprFormPagedList = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/form/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取折旧测试结果
exports.getAssetDeprFormDeprExecSnapList = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/form/deprExecSnap/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取折旧测试结果分页列表
exports.getAssetDeprFormDeprExecSnapPagedList = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/form/deprExecSnap/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 折旧单手工确认
exports.updateAssetDeprFormLedgerState = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/form/ledgerState/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 折旧单创建业务凭单
exports.doCreateYWPDByFormId = function (data, callback) {
    api.post('/asset/fiscal/create/ywpd/by/formId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// =================== 资产折旧计划项 ==============================

exports.getAssetDeprPlanItemsByFilter = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/plan/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 折旧计划报表
exports.getAssetDeprPlanItemReportByFilter = function (data, callback) {
    api.post('/asset/fiscal/asset/depr/plan/report/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// =================== 资产财务清账 ==============================

// 资产财务清账单分页列表
exports.getAssetFiscalClearVoucherList = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取资产财务清账单信息
exports.getAssetFiscalClearVoucherInfo = function (params, callback) {
    api.get('/asset/fiscal/clear/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};

// 待办-出账单(未申请未审核)
exports.getAssetFiscalClearVoucherApplyStateInitialTodoCount = function (params, callback) {
    api.get('/asset/fiscal/clear/voucher/applyState/initial/to-do/count/get')
    .params(params)
    .done(callback)
    .go();
};

// 待办-出账单(已申请未审核)
exports.getAssetFiscalClearVoucherApplyStateAppliedTodoCount = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/applyState/applied/to-do/count/get')
    .data(postData)
    .done(callback)
    .go();
};

// 待办-出账单(已申请审核不通过)
exports.getAssetFiscalClearVoucherAuditStateAuditFailTodoCount = function (params, callback) {
    api.get('/asset/fiscal/clear/voucher/auditState/auditFail/to-do/count/get')
    .params(params)
    .done(callback)
    .go();
};

// 保存资产财务清账单
exports.saveAssetFiscalClearVoucher = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 申请资产财务清账单
exports.applyAssetFiscalClearVoucher = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};
// 审核资产财务清账单
exports.aduitAssetFiscalClearVoucher = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/aduit/do')
    .data(postData)
    .done(callback)
    .go();
};
// 资产财务清账单手工确认
exports.updateAssetFiscalClearVoucherLedgerState = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/ledgerState/update/do')
    .data(postData)
    .done(callback)
    .go();
};
// 删除资产财务清账单
exports.deleteAssetFiscalClearVoucher = function (postData, callback) {
    api.post('/asset/fiscal/clear/voucher/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// ----------------------------- 入账单相关 -------------------------------
//
exports.getAssetFiscalEnterVoucherList = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.getAssetFiscalEnterVoucherInfo = function (params, callback) {
    api.get('/asset/fiscal/enter/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.saveAssetFiscalEnterVoucher = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.updateAssetFiscalEnterVoucher = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/update/do')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.applyAssetFiscalEnterVoucher = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.aduitAssetFiscalEnterVoucher = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/aduit/do')
    .data(postData)
    .done(callback)
    .go();
};
//
exports.deleteAssetFiscalEnterVoucher = function (postData, callback) {
    api.post('/asset/fiscal/enter/voucher/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// ----------------------------- 资产折旧调整单 -------------------------------
// 资产折旧调整单列表
exports.getAssetDeprAdjustVoucherList = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 资产折旧调整单信息
exports.getAssetDeprAdjustVoucherInfo = function (params, callback) {
    api.get('/asset/fiscal/depr/adjust/voucher/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 折旧调整检查结果
exports.getAssetDeprAdjustCheckResult = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/check/result/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取折旧月份列表
exports.getAssetDeprMonthList = function (data, callback) {
    api.post('/asset/fiscal/deprMonth/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 校验重算月份是否可以重算
exports.doValidateDeprMonthRecalAvailable = function (data, callback) {
    api.post('/asset/fiscal/validate/deprMonth/recal/available')
    .data(data)
    .done(callback)
    .go();
};
// 折旧调整试算
exports.doAssetDeprAdjustTrialCalculation = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/check/trial/calculation/do')
    .data(data)
    .done(callback)
    .go();
};
// 折旧调整试算-batch
exports.doAssetDeprAdjustTrialCalculationBatch = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/check/trial/calculation/batch/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存资产折旧调整单
exports.saveAssetDeprAdjustVoucher = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};
// 申请资产折旧调整单
exports.applyAssetDeprAdjustVoucher = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/apply/do')
    .data(postData)
    .done(callback)
    .go();
};
// 审核资产折旧调整单
exports.aduitAssetDeprAdjustVoucher = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/aduit/do')
    .data(postData)
    .done(callback)
    .go();
};
// 资产折旧调整单业务冲销
exports.doPullBackAssetDeprAdjustVoucherById = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/pullBack/do')
    .data(data)
    .done(callback)
    .go();
};
// 资产折旧调整单业务冲销申请
exports.doApplyAssetDeprAdjustVoucherPullBack = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/pullBack/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 资产折旧调整单业务冲销审核
exports.doAuditAssetDeprAdjustVoucherPullBack = function (data, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/pullBack/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 资产折旧调整单作废
exports.updateAssetDeprAdjustVoucherInvalid = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/invalid/update/do')
    .data(postData)
    .done(callback)
    .go();
};
// 资产折旧调整单重新生成
exports.createAssetDeprAdjustVoucher = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/crate/do')
    .data(postData)
    .done(callback)
    .go();
};
// 资产折旧调整单重新执行
exports.saveAssetDeprAdjustAuditPassAgain = function (postData, callback) {
    api.post('/asset/fiscal/asset/depr/adjust/aduit/pass/again')
    .data(postData)
    .done(callback)
    .go();
};
// 删除资产折旧调整单
exports.deleteAssetDeprAdjustVoucher = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// 待办-折旧调整单(未申请未审核)
exports.getAssetDeprAdjustVoucherApplyStateInitialTodoCount = function (params, callback) {
    api.get('/asset/fiscal/depr/adjust/voucher/applyState/initial/to-do/count/get')
    .params(params)
    .done(callback)
    .go();
};

// 待办-折旧调整单(已申请未审核)
exports.getAssetDeprAdjustVoucherApplyStateAppliedTodoCount = function (postData, callback) {
    api.post('/asset/fiscal/depr/adjust/voucher/applyState/applied/to-do/count/get')
    .data(postData)
    .done(callback)
    .go();
};

// 待办-折旧调整单(已申请审核不通过)
exports.getAssetDeprAdjustVoucherAuditStateAuditFailTodoCount = function (params, callback) {
    api.get('/asset/fiscal/depr/adjust/voucher/auditState/auditFail/to-do/count/get')
    .params(params)
    .done(callback)
    .go();
};

// 折旧计划信息执行
exports.execDeprPlanInfo = function (data, callback) {
    let ajax = api.post('/asset/fiscal/depr/plan/info/exec');
    //
    ajax.data(data)
    .done(callback)
    .go();
};

// ========================= 资产财务出账明细 ================
exports.getAssetFiscalOutItemList = function (postData, callback) {
    api.post('/asset/fiscal/out/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/assetFiscal.js
// module id = 51
// module chunks = 0